<template>
    <div class="footer" :class="device">
        <div>
            <span class="tag">{{ $t('footer.contact') }}</span
            >{{ $t('footer.program-name') }}
        </div>
        <div>
            <span class="tag">{{ $t('footer.website') }}</span
            ><a href="https://ecusr.ncu.edu.tw/" target="_blank">https://ecusr.ncu.edu.tw/</a>
        </div>
        <div>
            <span class="tag">{{ $t('footer.email') }}</span
            >ncuceusr@g.ncu.edu.tw
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    props: {
        device: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.footer {
    width: 100vw;
    background-color: #b6c7c2e3;
    color: #3d4746;

    a {
        color: #3d4746;
    }

    .tag {
        font-weight: bold;
    }

    &.desktop {
        min-height: 8vh;
        height: fit-content;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    &.mobile {
        @media (orientation: portrait) {
            height: 20vh;
            width: 100vw;
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-evenly;
            align-items: center;
        }
        @media (orientation: landscape) {
            display: none;
        }
    }
}

@media (max-width: 1536px) {
    .footer {
        font-size: 1rem; /* 字體稍微縮小 */
    }
    .footer.desktop {
        min-height: 8vh; /* 減少高度佔用 */
    }
}

@media (max-width: 1280px) {
    .footer {
        font-size: 0.75rem; /* 繼續縮小 */
    }
    .footer.desktop {
        min-height: 8vh;
        flex-wrap: wrap; /* 如果縮放到 150%，允許裡面的字斷行，不要硬擠 */
    }
}
</style>
